import jwtDecode from 'jwt-decode';
import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useLocation } from 'react-router-dom';
import { Userpilot } from 'userpilot';
import { AccessToken } from '@app-types/Token';
import { getSelf } from '@apis/users';

export default function UserPilotContainer(): null {
  const { user } = useAuth();
  const userUuid = user?.profile.sub || '';
  const location = useLocation();

  const getProducts = () => {
    if (!user) {
      return [];
    }

    const { product_roles } = jwtDecode<AccessToken>(user.access_token);

    const validProductRoles = Object.entries(product_roles).filter(
      ({ 1: roles }) => roles.length
    );

    return validProductRoles.map(([product]) => product);
  };

  const getRoles = () => {
    if (!user) {
      return [];
    }

    const { product_roles } = jwtDecode<AccessToken>(user.access_token);

    return Object.entries(product_roles).flatMap(({ 0: product, 1: roles }) => {
      if (product == 'LAB') {
        return roles;
      }
      return [];
    });
  };

  const getExtendedUserIdentity = async () => {
    const self = await getSelf();

    if (!self) {
      return {};
    }

    return {
      professional_role: self.professionalRole,
      professional_experience: self.professionalExperience,
      professional_subjects: self.professionalSubjects,
      ...(self.account
        ? {
            company: {
              id: self.account.uuid,
              name: self.account.name,
            },
          }
        : {}),
    };
  };

  const initializeUserPilot = async () => {
    if (!userUuid) {
      //Userpilot.anonymous();
      return;
    }

    const extendedIdentity = await getExtendedUserIdentity();

    Userpilot.identify(userUuid, {
      name: `${user?.profile.given_name} ${user?.profile.family_name}`,
      email: user?.profile.email,
      products: getProducts(),
      roles: getRoles(),
      ...extendedIdentity,
    });
  };

  useEffect(() => {
    initializeUserPilot();
  }, [user]);

  useEffect(() => {
    Userpilot.reload();
  }, [location]);

  return null;
}
